import { useEffect } from "react";
import { FiInfo, FiImage, FiFile, FiFileText } from "../../assets/icons/vander";

export const MedicalExams = ({ scheduleEvents = [] }) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  //   useEffect(() => {
  //     console.log("scheduleEvents:", scheduleEvents);
  //   }, [scheduleEvents]);

  const hasNoFiles =
    scheduleEvents.length > 0 &&
    scheduleEvents.every((event) => event.eventFiles.length === 0);

  if (scheduleEvents.length === 0 || hasNoFiles) {
    return (
      <div className="alert bg-soft-yellow fw-medium" role="alert">
        <FiInfo className="fs-5 align-middle me-1" />
        El paciente no ha subido exámenes médicos.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {scheduleEvents.map((scheduleEvent) =>
        scheduleEvent.eventFiles.map((file) => {
          const { mimeType, url, fileName } = file;

          let icon = <FiFile className="me-2" />;
          let label = "Archivo";

          if (mimeType.includes("image")) {
            icon = <FiImage className="me-2 text-blue-500" />;
            label = "Imagen";
          } else if (mimeType === "application/pdf") {
            icon = <FiFileText className="me-2 text-red-500" />;
            label = "PDF";
          }

          return (
            <div key={fileName} className="flex items-center space-x-2">
              {icon}
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm underline hover:text-blue-600"
              >
                {label}: {fileName}
              </a>
            </div>
          );
        })
      )}
    </div>
  );
};
